import { css, styled } from '../../hooks/theme';

interface TabButtonProps {
  selected?: boolean;
}

export const Container = styled.div``;

export const TabHeader = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.neutral.grey[70]};

  line-height: 150%;

  display: flex;
  align-items: center;
  flex-direction: row;

  svg {
    height: 18px;
    width: 18px;
  }
`;

export const TabButton = styled.button<TabButtonProps>`
  box-sizing: content-box;
  height: 19px;
  padding: 12px;
  gap: 8px;

  font-size: 14px;
  color: ${props => props.theme.colors.neutral.grey[70]};

  border: none;
  background: none;

  cursor: pointer;

  display: flex;
  align-items: center;

  img {
    height: 15px;
  }

  ${props =>
    props.selected &&
    css`
      font-weight: bold;
      color: ${props => props.theme.colors.neutral.bg.dark};
      border-bottom: 2px solid ${props => props.theme.colors.brand.primary[100]};
    `}
`;

export const CountContainer = styled.div`
  padding: 0 6px;

  font-size: 12px;
  line-height: 150%;
  color: ${props => props.theme.colors.neutral.grey[70]};

  border-radius: 100px;
  background: ${props => props.theme.colors.neutral.grey[10]};
`;
